// extracted by mini-css-extract-plugin
export default {"paper":"notFound_paper__ZlV9R","container":"notFound_container__-hdqi","title":"notFound_title__t82c6","bodyDesc":"notFound_bodyDesc__p6nW9","linkBtn":"notFound_linkBtn__hrR9i"};